import React from 'react';

import Lock from '@ast/magma/components/icon/icons/Lock';

import { FieldInfoGroupField } from '@app/common/configurable-wizards';
import { FieldComponent, FieldLocator } from '@app/common/configurable-wizards/types';
import { isFieldInfoGroupField } from '@app/common/configurable-wizards/utils';

import { useUserSettingsTranslation } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';
import { PasswordFields } from '@app/widgets/contacts-and-settings/types';

import { ProfileAndSecurityFieldsListItem } from '../../FieldsListItem';

export const DisplayPasswordField: FieldComponent<FieldInfoGroupField> = () => {
  const { t } = useUserSettingsTranslation();
  return (
    <ProfileAndSecurityFieldsListItem
      icon={<Lock />}
      title={t(
        'profile-and-security.display-password.label|Represents the label of the password item in the display mode',
        'Password',
      )}
      value={t(
        'profile-and-security.display-password.value|Represents the display value of the password in the display mode',
        '••••••••••••',
      )}
    />
  );
};

export const DisplayPasswordFieldLocator: FieldLocator = ({ field }) => (
  isFieldInfoGroupField(field) && field.id === PasswordFields.PasswordReset
    ? DisplayPasswordField
    : undefined
);
